import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAuth } from 'firebaseHooks/AuthContext';
import useGlobal from 'global-state/store';

export default function SentryScopeSync() {
  const { currentUser } = useAuth();
  const [globalState] = useGlobal();

  useEffect(() => {
    if (currentUser?.uid) {
      Sentry.setUser({ id: currentUser.uid });
    } else {
      Sentry.setUser(null);
    }

    Sentry.setTag('organization_id', globalState.activeOrganization || 'none');
    Sentry.setTag('user_status', globalState.userStatus || 'unknown');
    Sentry.setContext(
      'organization',
      globalState.activeOrganization
        ? { id: globalState.activeOrganization, userStatus: globalState.userStatus }
        : null,
    );
  }, [currentUser?.uid, globalState.activeOrganization, globalState.userStatus]);

  return null;
}
